<template>
  <main id="master-rates-main">
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('masterRates.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter-list ref="searchFilterList" @search="onSearch"/>
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="7" class="default-section-title">
              <span >{{ $t('masterRates.summary') }}</span>
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="10"  class="default-section-title totals-section">
               <el-row class="default-section-header"></el-row>
            </el-col>
            <el-col :span="7" class="default-section-actions text-align-end">
              <download-csv/>
              <span id="manage-shipment-more-actions-section">
                <add-master-rate @add-master-rate="addMasterRatesToSummary" />
              </span>
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary-list ref="summaryList" :warehouse-list="warehouseList" />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import apiConstants from '@/utils/apiConstants';
import selectService from '@/api/selectService';
import constants from '@/utils/constants';
import { MINIMUM_SEARCH } from '@/store/actions';
import SearchFilterList from './SearchFilterList';
import SearchSummaryList from './SearchSummaryList';
import AddMasterRate from './components/addMasterRate/AddMasterRate';
import DownloadCsv from './components/downloadCSV/DownloadCSV';

export default {
  name: 'DaysOfService',
  components: {
    SearchSummaryList,
    SearchFilterList,
    AddMasterRate,
    DownloadCsv
  },
  mounted() {
    this.getAllWarehouses();
    this.onSearch();
  },
  computed: {
    ...mapGetters([
      'minimumManagement'
    ]),
  },
  data() {
    return {
      listView: 'billing.minimum.listView',
      showListView: false,
      actionSelectChained: [],
      consignees: constants.ACCOUNTS.TYPE[2].value,
      selectedRow: null,
      urlWarehouses: apiConstants.END_POINTS.BILLING.WAREHOUSE,
      warehouseList: [],
      accountReady: false,

    };
  },

  watch: {
    accountReady(newVal) {
      if (newVal) {
        if (this.$can(this.permissions.DAY_OF_SERVICE.VIEW_LIST_DAY_OF_SERVICE)) {
          this.actionSelectChained.push('minimumManagement/search');
        }
        if (this.$can(this.permissions.DAY_OF_SERVICE.VIEW_LIST_DAY_OF_SERVICE)) {
          this.showListView = true;
        }
      }
    }
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilterList.handleSearch();
    },
    onSearch() {
      this.$refs.searchFilterList.handleSearch();
    },
    addMasterRatesToSummary(newMinimum) {
      this.$refs.summaryList.addMasterRate(newMinimum);
    },
    handleSearch() {
      this.$store.dispatch(MINIMUM_SEARCH, this.searchForm);
    },
    listViewToShow() {
      return this.showListView && this.$can(this.permissions.DAY_OF_SERVICE.VIEW_LIST_DAY_OF_SERVICE);
    },
    getAllWarehouses() {
      selectService.getList(this.urlWarehouses).then((response) => {
        if (response instanceof Array) {
          this.warehouseList = response;
        } else if (response.data && response.data instanceof Array) {
          this.warehouseList = response.data;
        }
      });
    },

  }
};
</script>
